import { render, staticRenderFns } from "./DebrisFormulaDialog.vue?vue&type=template&id=f8d1d206&scoped=true&"
import script from "./DebrisFormulaDialog.vue?vue&type=script&lang=js&"
export * from "./DebrisFormulaDialog.vue?vue&type=script&lang=js&"
import style0 from "./DebrisFormulaDialog.vue?vue&type=style&index=0&id=f8d1d206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d1d206",
  null
  
)

export default component.exports